import script from "./RadiogroupRadio_tabs.vue?vue&type=script&lang=js"
export * from "./RadiogroupRadio_tabs.vue?vue&type=script&lang=js"

import "./RadiogroupRadio_tabs.vue?vue&type=style&index=0&id=93720304&lang=scss"

const __exports__ = script;

export default __exports__